var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fade-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"na-popup",style:({
      top: _vm.posY + 'px',
      left: _vm.posX + 'px',
    })},[_vm._v("Not Available"),_c('br'),_vm._v("in demo")])])}
var staticRenderFns = []

export { render, staticRenderFns }